import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom'
import Services from '../../api/Services';
import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'
import HeaderTop from '../../components/HeaderTop/HeaderTop'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import CtaSection from '../../components/CtaSection/CtaSection';
import MapSection from '../../components/MapSection/MapSection';
import FooterS2 from '../../components/FooterS2/FooterS2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import Gvideo from '../../images/service-single/video.jpg'

const ServiceSinglePage = (props) => {
    const { slug } = useParams()
    const serviceDetails = Services.find(item => item.slug === slug) || Services[0]

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            <section className="wpo-service-single-page section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <div className="title-image">
                                    <img src={serviceDetails.simag} alt={serviceDetails.title} />
                                </div>
                                <h2>{serviceDetails.title}</h2>
                                <p>{serviceDetails.overview}</p>
                                <p>{serviceDetails.details}</p>
                                <h3>{serviceDetails.focusTitle}</h3>
                                <ul className='service-focus-list'>
                                    {serviceDetails.focusPoints.map((point) => (
                                        <li key={point}>{point}</li>
                                    ))}
                                </ul>
                                <div className='service-approach'>
                                    <h3>{serviceDetails.approachTitle}</h3>
                                    <div className='service-approach-grid'>
                                        {serviceDetails.approachSteps.map((step) => (
                                            <div className='service-approach-card' key={step.title}>
                                                <span>{step.title}</span>
                                                <p>{step.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="video-wrap">
                                    <div className="video-img">
                                        <img src={Gvideo} alt={`${serviceDetails.title} overview`} />
                                    </div>
                                    <div className="video-content">
                                        <h2>{serviceDetails.videoTitle}</h2>
                                        <p>{serviceDetails.videoText}</p>
                                        <ul>
                                            {serviceDetails.videoPoints.map((point) => (
                                                <li key={point}>{point}</li>
                                            ))}
                                        </ul>

                                    </div>
                                </div>
                                <div className='service-benefit-wrap'>
                                    <div className='service-benefit-card'>
                                        <h3>{serviceDetails.benefitsTitle}</h3>
                                        <ul>
                                            {serviceDetails.benefits.map((item) => (
                                                <li key={item}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className='service-benefit-card accent'>
                                        <h3>{serviceDetails.useCasesTitle}</h3>
                                        <ul>
                                            {serviceDetails.useCases.map((item) => (
                                                <li key={item}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <h3 className="quate">{serviceDetails.quote}</h3>
                                <Accordion items={serviceDetails.faq} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar/>
                        </div>
                    </div>
                </div>
            </section>
            <MapSection />
            <CtaSection hclass={'wpo-cta-section-s2'} />
            <FooterS2 />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;



